<template>
  <vs-popup :active.sync="isActiveLocal" title="Personal Satış Detayları" v-esc="escape" id="personalReviewer"
    v-if="personalInfo != null">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" id="personalInfoRow" class="px-4">
        <vs-col vs-type="flex" vs-w="6" vs-align="center" class="px-1">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" class="pl-3">
              <v-select autocomplete="false" class="w-1/3 weight-500" :clearable="false" itemid="id" label="name"
                v-model="tableOptions.month" :options="months" />
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="py-4">
              <vs-col vs-type="flex" vs-w="4" class="px-2">
                <img class="responsive sale-box-shadow low-border-radius" :src="getAvatar(personalInfo.image)">
              </vs-col>
              <vs-col vs-type="flex" vs-w="8" class="px-2">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-dark text-small bold">
                      {{personalInfo.name}}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{personalInfo.branchName}}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{personalInfo.beingWorkingMonths}} Aydır Çalışıyor
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{personalInfo.email}}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{personalInfo.phone}}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" vs-align="center" class="px-1">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <span v-if="personalInfo.targets.length > 0" class="text-dark weight-600 text-smaller">
                Güncel Hedef Durumu
              </span>
              <span v-else class="text-dark weight-600 text-smaller">
                Kayıtlı Hedef Bulunamadı !
              </span>
            </vs-row>
            <vs-row id="personalTargets" vs-type="flex" class="mt-2">
              <vs-col vs-type="flex" vs-w="3.5" v-for="(target,index) in personalInfo.targets" :key="index">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                    <radial-progress-bar :strokeWidth="11" innerStrokeColor="#F5F5F5"
                      :startColor="target.kind == 1 ? '#3ce8c4' : '#8ee0e8'"
                      :stopColor="target.kind == 1 ? '#3ce8c4' : '#8ee0e8'" v-if="target.status == 1"
                      :diameter="95" :completed-steps="target.targetProcess * 100 / target.targetQuantity"
                      :total-steps="100">
                      <span class="text-smaller bold">
                        {{(target.targetProcess * 100 / target.targetQuantity).toFixed(2)}}%
                      </span>
                    </radial-progress-bar>
                    <radial-progress-bar :strokeWidth="11"
                      :startColor="target.kind == 1 ? '#3ce8c4' : '#8ee0e8'"
                      :stopColor="target.kind == 1 ? '#3ce8c4' : '#8ee0e8'" v-if="target.status == 2"
                      :diameter="95" :completed-steps="100" :total-steps="100">
                      <span class="text-smaller bold">
                        100%
                      </span>
                    </radial-progress-bar>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                    <span v-if="target.kind == 1" class="text-dark weight-600 text-xsmall">
                      {{target.targetProductName}}
                    </span>
                    <span v-if="target.kind == 2" class="text-dark weight-600 text-xsmall">
                      Ciro
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" vs-justify="center">
                    <span v-if="target.kind == 1" class="text-secondary weight-600 text-xsmall">
                      {{target.targetProcess + ' / ' + target.targetQuantity}} Adet
                    </span>
                    <span v-else class="text-secondary weight-600 text-xsmall">
                      {{target.targetProcess + ' / ' + target.targetQuantity}}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" id="personalChips" vs-justify="center" class="py-4 my-4">
        <vs-col vs-type="flex" vs-w="3" class="px-1">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <vs-col class="personalChipIcon" vs-type="flex" vs-align="center">
              <vs-button size="large" color="#DFEFEF" class="w-full sale-box-shadow" icon-pack="pickicon"
                icon="icon-rich" radius />
            </vs-col>
            <vs-col vs-type="flex" vs-w="8" vs-align="center" class="pl-2">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-dark bold text-small">
                      {{personalInfo.timesReachedTarget + ' / ' + personalInfo.targets.length}}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary weight-600 text-xsmall">
                      Hedefine Ulaştı !
                    </span>
                  </vs-row>
                </vs-row>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-w="3" class="px-1">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <vs-col class="personalChipIcon" vs-type="flex" vs-align="center">
              <vs-button size="large" color="#FFF4E9" class="w-full sale-box-shadow" icon-pack="pickicon"
                icon="icon-rich" radius />
            </vs-col>
            <vs-col vs-type="flex" vs-w="8" vs-align="center" class="pl-2">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-dark bold text-small">
                      {{personalInfo.madeGiro}}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary weight-600 text-xsmall">
                      Ciro Yaptı !
                    </span>
                  </vs-row>
                </vs-row>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-w="3" class="px-1">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <vs-col class="personalChipIcon" vs-type="flex" vs-align="center">
              <vs-button size="large" color="#FFE4E9" class="w-full sale-box-shadow" icon-pack="pickicon"
                icon="icon-rich" radius />
            </vs-col>
            <vs-col vs-type="flex" vs-w="8" vs-align="center" class="pl-2">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-dark bold text-small">
                      {{personalInfo.completedOrder}} Müşteri
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary weight-600 text-xsmall">
                      Moodlu Etti !
                    </span>
                  </vs-row>
                </vs-row>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" id="personalGraph" class="px-4 pb-4">
        <vs-row vs-type="flex" vs-w="12" vs-justify="center">
          <line-chart :chart-data="datacollection" :options="datacollection.options"></line-chart>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
  import LineChart from './LineChart.js'
  import {
    getPersonalReviewer
  } from "@/api/User.js"
  import RadialProgressBar from "vue-radial-progress";
  export default {
    props: ['userId', 'isActive'],
    components: {
      RadialProgressBar,
      LineChart
    },
    data() {
      return {
        datacollection: null,
        personalInfo: null,
        tableOptions: {},
        months: [{
            id: 0,
            name: 'Tümü'
          },
          {
            id: 1,
            name: 'Ocak'
          }, {
            id: 2,
            name: 'Şubat'
          }, {
            id: 3,
            name: 'Mart'
          }, {
            id: 4,
            name: 'Nisan'
          }, {
            id: 5,
            name: 'Mayıs'
          }, {
            id: 6,
            name: 'Haziran'
          }, {
            id: 7,
            name: 'Temmuz'
          }, {
            id: 8,
            name: 'Ağustos'
          }, {
            id: 9,
            name: 'Eylül'
          }, {
            id: 10,
            name: 'Ekim'
          }, {
            id: 11,
            name: 'Kasım'
          }, {
            id: 12,
            name: 'Aralık'
          }
        ],
      }
    },
    methods: {
      fillLineChart() {
        this.datacollection = {
          labels: this.personalInfo.lineChart.labels,
          datasets: [{
            data: this.personalInfo.lineChart.dataValues,
            label: this.personalInfo.name,
            borderColor: "#3ce8c4",
            fill: false,
            lineTension: 0
          }],
          options: {
            responsive: true,
            title: {
              display: true,
              text: this.tableOptions.month.id == 0 ? "Senelik Satış Grafiği" : this.tableOptions.month.name +
                ' Ayı için Günlük Satış Grafiği'
            },
            scales: {
              xAxes: [{
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: 'Gün',
                  fontFamily: 'inherit'
                }
              }],
              yAxes: [{
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: 'Ciro (₺)',
                  fontFamily: 'inherit'
                }
              }]
            }
          }
        }
      },
      getAvatar(image) {
        if (!image) return this.$nullImage;
        else return this.$baseUrl + '/' + image;
      },
      escape() {
        if (this.isActiveLocal == true) this.isActiveLocal = false;
      },
      getPersonalReviewer() {
        getPersonalReviewer(this.tableOptions).then(res => {
          if (res && res.status) {
            this.personalInfo = res.data;
            this.fillLineChart();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Personal Bilgileri Getirilemedi !"
            });
          }
        }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: error
          });
        });
      }
    },
    computed: {
      isActiveLocal: {
        get() {
          return this.isActive;
        },
        set(val) {
          if (val == false) this.$emit("close");
        }
      }
    },
    watch: {
      tableOptions: {
        deep: true,
        handler(val) {
          if (!this.isActiveLocal) return;
          this.getPersonalReviewer();
        }
      },
      isActiveLocal(val) {
        if (val == false) {
          this.personalInfo = null;
          this.tableOptions = {};
        } else if (val == true) {
          this.tableOptions = {
            month: this.months.find(x => x.id == (this.$now.date().getMonth() + 1)),
            userId: this.userId
          };
        }
      }
    },
  }

</script>

<style>
  #personalReviewer .vs-popup {
    width: 800px !important;
  }

  .personalChipIcon {
    width: 45px !important;
  }

  #personalChips {
    border-top: 1px solid #E4E4E4;
    border-bottom: 1px solid #E4E4E4;
    box-shadow: 0px 1px 0px #E4E4E4, 0px -1px 0px #E4E4E4;
    background-color: #F1F1F1
  }

  #personalReviewer .vs-popup--title {
    display: none;
  }

  #personalReviewer .vs-popup--header {
    justify-content: flex-end !important;
    background-color: transparent !important;
    height: 20px;
  }

  #personalReviewer .vs-popup--content {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
  }

  #personalReviewer #personalTargets {
    width: auto !important;
    flex-wrap: nowrap !important;
    overflow-x: auto;
  }

  #personalReviewer #line-chart {
    height: 380px !important;
  }

  .personalChipIcon i {
    color: black !important;
    font-weight: 500 !important;
    font-size: 25px !important;
  }

  #personalReviewer .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    width: 100% !important;
    min-width: unset !important;
  }

  #personalReviewer .vs__dropdown-toggle {
    border: none !important;
    border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
    border-radius: 0;
    padding: 0 !important;
  }

</style>
